import {call, put} from 'redux-saga/effects';
import {deliveryMetadataUpdates} from '@pluto/rest';
import {setNotificationError} from '@pluto/notification';

interface Props {
    type: string;
    payload: number;
}

export function* deliveryMetadata({payload: id}: Props) {
    try {
        yield call(deliveryMetadataUpdates, id);
    } catch (error) {
        yield put(setNotificationError(error.message));
    }
}
